module.exports = __webpack_public_path__ + "img/39_27.6144bba3.png";